import React from "react";
import LinkifiedText from "../linkified_text";
import { getText } from "../../helpers";

export function TranslationDetails(props) {
  const { translation, control } = props;

  if (!translation) return null

  return (
    <div className="translation-library-control-details">
      <div className="control-details">
        <strong>{control.custom_id}</strong>&nbsp;
        <span className="control-title">{translation.title}</span>
        <span> / </span>
        <span className="control-subtitle">{translation.subtitle}</span>
      </div>
      <div className="control-description">
        <LinkifiedText text={translation.description} />
      </div>
      <div className="control-ids">
        <span className="control-id">
          <label>{getText("System Id").toUpperCase()}:</label> {control.id}
        </span>
        <span> / </span>
        <span className="custom-id">
          <label>{getText("Custom Id").toUpperCase()}:</label> {control.custom_id}
        </span>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/translation_modal/translation_details.js